import { connect } from 'react-redux';
import PendingAccreditationsList from "./PendingAccreditationsList";
import {
    fetchGetPendingAccreditations,
    getPendingAccreditationsListData,
    loadingPendingAccreditations
} from "../../../reducers/applicantAccreditations/pendingAccreditations";
import { getTranslation } from "../../../reducers/common/localization";

const mapStateToProps = state => {
    return {
        data: getPendingAccreditationsListData(state),
        loading: loadingPendingAccreditations(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onGetAccreditations: () => dispatch(fetchGetPendingAccreditations())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PendingAccreditationsList);



// WEBPACK FOOTER //
// ./src/components/applicantAccreditationsManagement/pendingAccreditationsList/PendingAccreditationsList.container.js